import { i18n } from '@umanforge/common';
import { dayjs } from '@umanforge/common';
import weekday from 'dayjs/plugin/weekday';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend( weekday );

export class DateLocaleService {

  static displayDate( date: dayjs.Dayjs | null, format?: string, locale?: string ): string {
    dayjs.extend( localizedFormat );
    if ( !date ) {
      date = dayjs();
    }

    if ( !locale ) {
      locale = i18n.language;
    }

    // Custom format is 'dddd D MMMM' but taking locale format ( for example 'en' is 'dddd, MMMM D' )
    // Making this custom format because Dayjs Localized format doesn't have this one.
    if ( format === 'custom' ) {
      const str: string[] = date.locale( locale ).format( 'LLLL' ).split( ' ' );

      // Locale 'hu' put his year in first place
      if ( locale === 'hu' ) {
        return `${str[ 1 ]} ${str[ 2 ].replace( ',', '' )} ${str[ 3 ]}`;
      }
      return `${str[ 0 ]} ${str[ 1 ]} ${str[ 2 ].replace( ',', '' )}`;
    }


    return date.locale( locale ).format( format );
  }

  static getWeekDay( index: number ): string {
    return this.displayDate( dayjs().weekday( index ), 'ddd DD' );
  }
};